import script from "./ListShipOwnerCompany.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListShipOwnerCompany.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__